module.exports = __webpack_public_path__ + "img/75.44ddcf9f.svg";